module.exports = __webpack_public_path__ + "static/media/congress.ab693cfa.jpg";